<template>
	<cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :footer="footer" :config="config">
		
	</cTable>
</template>

<script>
	import {
	  getList,
		del,
		update,
		add,
		getDetails,
	} from "@/api/finance/freight_discount";
	import cTable from "@/base/common/index";
	export default {
		components:{
			cTable
		},
		data() {
			return {
				config:{
					slot:'div'
				},
				methods:{
					list:getList,
					del,
					update,
					add,
					getDetails,
					beforeHandleList({data}){
						return data
					}
				},
				footer:{
					show:()=>false,
				},
				header:{
					btns:{
						list:[
							{
								name:this.$t('add'),
								type:'add',
								fnName:'add',
								bind:{
									type:'primary'
								}
							}
						],
						methods:{
							add(){
								this.getModal('add').open(null,function(){
									this.setTitle('add')
								})
							},
						}
					}
				},
				modals:{
					add:{
						methods:{
							ok({row,close}){
								this.$page.handleRequestMethods(row.id?'update':'add',row,true,true).then(_=>this.$page.getList(),close())
							}
						},
						config: {
							title: this.$t("add"),
							modalBind: {
								width: 600,
								draggable: true
							},
							formBind: {
								labelWidth: 120
							},
							colBind: {
								style: {
									marginBottom: "20px"
								}
							},
							rules: {
								name: [{required: true,trigger: "blur",}],
								discount: [{required: true,trigger: "change",min:0.1,max:1,type:'number'}],
							}
						},
						grid: [
							{
								name:24,
								mame_en:24,
								discount:24,
							},
						],
						fields: [
							{
								name: () => this.$t("invoiceName"),
								key: "name",
								placeholder:this.$t('invoiceName'),
								component: "Input",
							},
							{
								name: () => this.$t("currencyEnName"),
								key: "mame_en",
								placeholder:this.$t('currencyEnName'),
								component: "Input",
							},
							{
								name: () => this.$t("discount"),
								placeholder:this.$t('discount'),
								key: "discount",
								component: "InputNumber",
								bind: {
									step: 0.01,
									min: 0.1,
									max: 1,
									style: {
										width: "100%"
									}
								},
								default: 0
							},
						]
					}
				},
				fields:[
					{
						name:this.$t('invoiceName'),
						key:'name',
						minWidth:110
					},
					{
						name:this.$t('currencyEnName'),
						key:'name_en',
						minWidth:110
					},
					{
						name:this.$t('discount'),
						key:'discount',
						minWidth:110
					},
					{
						type: "btns",
						width: 150,
						name: () => this.$t("operation"),
						fixed: "right",
						list: [
							{
								name: () => this.$t("update"),
								type: "update",
								fnName: "updateFun",
								bind: {
									type: "success",
								},
								// id:1258
							},
							{
								name: () => this.$t("delete"),
								type: "delete",
								fnName: "deleteFun",
								bind: {
									type: "error",
								},
								// id:1259
							},
						],
						methods: {
							async updateFun({ row }) {
								this.handleRequestMethods('getDetails',row.id).then(res=>{
									this.getModal('add').open(res.payload,function(){
										this.setTitle(this.$t("update"));
									})
								})
							 
							},
							deleteFun({ row }) {
								this.$Modal.confirm({
									title:
										this.$t("whether") +
										this.$t("confirm") +
										this.$t("delete"),
									onOk: () => {
										this.handleRequestMethods("del", row, true).then((res) => {
											// this.$Message.success(res.data.msg);
											this.getList();
										});
									},
								});
							},
						},
					}
				]
			}
		},
	}
</script>

<style scoped>

</style>